import React, { useContext } from 'react';
import { Language as LanguageType } from '../types/Language';
import { ExperienceContext } from '../providers/ExperienceProvider';
const LanguageToggle = props => {
    const { en, es } = props;
    const { language } = useContext(ExperienceContext);
    return <>{language === LanguageType.SPANISH ? es : en}</>;
};
export default LanguageToggle;
